import { useApiUrl, useCustom } from "@refinedev/core";
import { SmlAsset } from "src/types/intelligence-search";

type GetAssetMetaResponse = {
    errors: [];
    meta: SmlAsset[];
};

export const useMeta = ({
    productCode,
    dataProviderName = "semantic",
    shouldFetchData = true,
}: {
    productCode?: string;
    dataProviderName?: string;
    shouldFetchData?: boolean;
}) => {
    const apiUrl = useApiUrl(dataProviderName);
    const { data, isFetching, isError, refetch } = useCustom<GetAssetMetaResponse>({
        url: `${apiUrl}/meta`,
        method: "get",

        config: {
            headers: {
                "product-code": productCode,
            },
        },
        dataProviderName: dataProviderName,
        queryOptions: {
            queryKey: ["meta", productCode],
            retry: 2,
            enabled: shouldFetchData && !!productCode,
            cacheTime: 10 * 60 * 1000,
        },
    });

    return {
        isLoading: isFetching,
        isError,
        meta: data?.data.meta,
        errors: data?.data.errors,
        refetch,
    };
};
